import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { CreateNewMenu } from './create-new-menu.tsx';
import { GlobalSearchBar } from './global-search-bar.tsx';
import { NavLogo } from './nav-logo.tsx';

export type MobileTopBarProps = {
    showCreateNew: boolean;
};

export const MobileTopBar: FC<MobileTopBarProps> = ({ showCreateNew }) => (
    <div className="relative z-40 flex items-center gap-3 border-b border-neutral-200 bg-white px-4 py-3 sm:hidden">
        <Link to="/" className="flex shrink-0 items-center justify-center h-9 w-9">
            <NavLogo className="h-8 w-auto" />
        </Link>
        <GlobalSearchBar showFullInput showShortcutKey={false} className="min-w-[120px] grow" />
        {showCreateNew && <CreateNewMenu showFullInput={false} />}
    </div>
);
